import React from 'react'

interface Props {
  phone: string
}

export const FormattedPhoneNumber = ({ phone }: Props) => {
  if (phone.length < 8) {
    return <span>{phone}</span>
  }

  const countryCode = phone.slice(0, 3)
  const firstPart = phone.slice(3, 6)
  const rest = phone.slice(6)

  return (
    <span>
      {countryCode}&nbsp;{firstPart}&nbsp;{rest}
    </span>
  )
}
